import styled from "styled-components";

export const MainContainer = styled.div`
  flex-direction: ${(props) => (props.$column ? "column" : "row")};
  background: #f6f6f9;
  min-height: 100vh;
  height: 100%;
  display: flex;
`;

export const HeaderWrapper = styled.div`
  position: fixed;
  z-index: 1000000;
  width: 100%;
  justify-content: center;
`;

export const Content = styled.div`
  height: 100%;

  min-height: calc(100dvh - 247px);
  display: flex;
  /* justify-content: center; */
  flex-direction: column;
  transition: all 0.3s ease-in-out;

  position: relative;

  padding: ${(props) =>
    props.$loggedIn
      ? props.$open
        ? props.$ar
          ? "4rem 30rem 8rem 4rem"
          : "4rem 4rem 8rem 30rem"
        : !props.$ar
        ? "4rem 4rem 8rem 10rem"
        : "4rem 10rem 8rem 4rem"
      : "4rem 4rem"};

  margin-top: 140px;
  @media (max-width: 1440px) {
    width: 100%;
  }
  @media (max-width: 1200px) {
    margin-top: 126px;
  }
  @media (max-width: 870px) {
    margin-top: 79px;
    padding: 2rem 2rem 8rem 2rem;
  }
  @media (max-width: 380px) {
    margin-top: 65px;
  }
`;
